import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MasterLogin from "./masterlogins/logins/MasterLogin";
//import DistributorLogin from './distributorlogins/DistributorLogin';
import CustomerLogin from "./customerlogins/CustomerLogin";

import MasterDashboard from "./masterlogins/dashboard/MasterDashboard";
import DistributorDashboard from "./distributorlogins/DistributorDashboard";
import CustomerDashboard from "./customerlogins/CustomerDashboard";

import ProtectedRoute from "./components/routes/ProtectedRoute"; // ✅ Import the wrapper
import DistributorProtectedRoute from "./components/routes/DistributorProtectedRoute";
import CustomerProtectedRoute from "./components/routes/CustomerProtectedRoute";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import UsersShow from "./masterlogins/dashboard/users/UsersShow"; // Import UsersShow component
import UsersAdd from "./masterlogins/dashboard/users/UsersAdd";
import DistributorsShow from "./distributors/DistributorsShow"; // Import DistributorsShow component
import DistributorsAdd from "./distributors/DistributorsAdd"; // Import DistributorsAdd component

import CustomersShow from "./customers/CustomersShow";
import CustomersAdd from "./customers/CustomersAdd";
import CustomerProfile from "./customers/CustomerProfile";

import Company from './customerlogins/company/Company';

////////////////CUSTOMER LOGIN

// Welcome screen component
function WelcomePage() {
  return (
    <div className="App d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-4 shadow rounded bg-white">
        <h1 className="mb-4">Welcome to Visitor Management System</h1>
        <p className="lead">Please choose your login type:</p>
        <div className="d-flex justify-content-center gap-3 mt-3">
          <a href="/master-login" className="btn btn-primary">
            Master Login
          </a>
          <a href="/distributor-login" className="btn btn-secondary">
            Distributor Login
          </a>
          <a href="/customer-login" className="btn btn-success">
            Customer Login
          </a>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<WelcomePage />} />
        <Route path="/master-login" element={<MasterLogin />} />
        <Route path="/customer-login" element={<CustomerLogin />} />
        <Route path="/customer/company" element={<Company />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />

        {/* Protected routes */}

        <Route element={<ProtectedRoute />}>
          <Route path="/master-dashboard" element={<MasterDashboard />} />
          <Route path="/users/show" element={<UsersShow />} />
          <Route path="/users/add" element={<UsersAdd />} />
          <Route
            path="/users/edit/:id/:master_user_token"
            element={<UsersAdd />}
          />

          <Route path="/distributors/show" element={<DistributorsShow />} />
          <Route path="/distributors/add" element={<DistributorsAdd />} />
          <Route
            path="/distributors/edit/:id/:distributor_token"
            element={<DistributorsAdd />}
          />

          {/* Customers */}
          <Route path="/customers/show" element={<CustomersShow />} />
          <Route path="/customers/add" element={<CustomersAdd />} />

          <Route
            path="/customers/edit/:id/:customer_token"
            element={<CustomersAdd />}
          />
          <Route
            path="/customers/profile/:id/:token"
            element={<CustomerProfile />}
          />

          {/* Distributor Routes */}
          <Route element={<DistributorProtectedRoute />}>
            <Route
              path="/distributor-dashboard"
              element={<DistributorDashboard />}
            />
            {/* add other distributor routes here */}
          </Route>

          {/* Customer Routes */}

          
        </Route>

        {/* Optional: Catch-all */}
        <Route path="*" element={<WelcomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
